import Spin from './Spin'

export default Spin
